import React, {useCallback, useContext} from 'react';

import {MessageContext} from 'src/contexts/message-context';

import {FlatButton} from '@pb/kit-component-button';
import {Dialog} from '@pb/kit-component-dialog-v2';
import {useShown} from '@pb/kit-hooks-use-shown';


import {RemoveSectionModal} from './remove-section.modal';
import {useRemoveSection} from './useRemoveSection';

type Props = {
    sectionId: number,
    sectionName: string,
    onRemove: () => void,
};

export const RemoveSection = ({onRemove, sectionId, sectionName}: Props) => {
    const {onClick, onClose, shown} = useShown();
    const {setSuccessMessage} = useContext(MessageContext);

    const {busy, event} = useRemoveSection({onSuccess: () => {
        onRemove();
        onClose();
        setSuccessMessage('Section deleted successfully');
    }});

    const removeSection = useCallback(() => {
        event(sectionId);
    }, [sectionId, event]);

    return (
        <>
            <FlatButton onClick={onClick}><b>Delete</b></FlatButton>
            <Dialog shown={shown} setShown={onClose} wrapperProps={{style: {width: 600}}}>
                <RemoveSectionModal
                    busy={busy}
                    sectionName={sectionName}
                    onRemove={removeSection}
                    onClose={onClose}
                />
            </Dialog>
        </>
    );
};
